import { render, staticRenderFns } from "./EmptyVideoScreen.vue?vue&type=template&id=1236572c&scoped=true"
import script from "./EmptyVideoScreen.vue?vue&type=script&lang=js"
export * from "./EmptyVideoScreen.vue?vue&type=script&lang=js"
import style0 from "./EmptyVideoScreen.vue?vue&type=style&index=0&id=1236572c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236572c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1236572c')) {
      api.createRecord('1236572c', component.options)
    } else {
      api.reload('1236572c', component.options)
    }
    module.hot.accept("./EmptyVideoScreen.vue?vue&type=template&id=1236572c&scoped=true", function () {
      api.rerender('1236572c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmptyVideoScreen.vue"
export default component.exports